
import * as React from "react";
import { ProjectState } from "../../../shared";

type Props = {
    project: ProjectState
}

function VideoTracks({ project }: Props) {
    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                backgroundColor: 'lightblue',
                color: 'white'
            }}>
                VideoTracks
        </div>
    );
}

export default VideoTracks;